import React, { Children } from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import AdxEmptyState from '../emptyState/AdxEmptyState'
import AdxEmptyStateV2 from '../emptyState/AdxEmptyStateV2'

const AdxTableBottomCTA = ({ bottomCTA, emptyStateComponent, children }) => {
  const arrayChildren = Children.toArray(children)

  return arrayChildren.length > 0 ? (
    <Box width={1} height={1} display="flex" flexDirection="column" boxSizing="border-box">
      <Box display="flex" flexDirection="column" flex={1}>
        {children}
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" padding={1.5}>
        {bottomCTA ? (
          bottomCTA
        ) : (
          <Typography
            variant="body1"
            color="alternate.main"
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => alert('View all button pressed')}
          >
            View All
          </Typography>
        )}
      </Box>
    </Box>
  ) : emptyStateComponent ? (
    emptyStateComponent
  ) : (
    <AdxEmptyStateV2 />
  )
}

export default AdxTableBottomCTA
